import {Component, Input} from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as countries from "i18n-iso-countries";
//import {LocalData} from "i18n-iso-countries/langs/fr.json"

@Component({
    templateUrl: './country-picker.component.html',
    styleUrls: ['./country-picker.component.scss'],
    selector: 'country-picker',
    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          multi:true,
          useExisting: CountryPickerComponent
        }
    ]
})

export class CountryPickerComponent implements ControlValueAccessor {
    form: UntypedFormControl;
    options:any[] = [];

    multiSelect = false;

    onChange = (value) => {};
    onTouched = () => {};

    touched = false;

    @Input()
    value:string ;

    @Input()
    title:string;

    disabled = false;


    constructor(public formBuilder: UntypedFormBuilder) {
        countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
        this.options = Object.keys(countries.getAlpha3Codes());
        this.form = new UntypedFormControl();
    }

    translateCountry(alpha3:string):string{
        return countries.getName(alpha3, "fr", {select: "official"});
    }
  
    ionViewWillEnter() {

    }

    ngOnInit(){

    }

    onInputChange(event){
        this.value = event.detail.value;
        this.markAsTouched();
        //this.writeValue(this.value);
        this.onChange(this.value);
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
        this.form.disable();
    }

    writeValue(value: string) {
        // console.log(value);
        if(value){
            this.value = value;
            this.form.setValue(value);          
        }
    }
    
    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    markAsTouched() {
        if (!this.touched) {
          this.onTouched();
          this.touched = true;
        }
      }
  }